import React, { useState, useEffect } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { LocalStorage } from '@shared/services/main/storage'
import ROUTES from '@shared/lib/constants/routes'

/**
 * Host-owned profile/settings page.
 * Remotes can open it via c7:settings:open; users can open via header Profile link.
 */
function ProfilePage() {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const [user, setUser] = useState(null)

  useEffect(() => {
    const u = LocalStorage.get('user')
    if (!u) {
      navigate(ROUTES.HOME, { replace: true })
      return
    }
    setUser(u)
  }, [navigate])

  if (!user) {
    return null
  }

  return (
    <section className="section section-lg bg-gray-100">
      <div className="container">
        <h3 className="mb-4">{t('profile') || 'Profile'}</h3>
        <div className="bg-white rounded-xl shadow border border-gray-200 p-6 max-w-lg">
          <p className="text-gray-600 mb-2">
            <span className="font-semibold">{t('name') || 'Name'}:</span>{' '}
            {user.firstname} {user.lastname}
          </p>
          <p className="text-gray-600 mb-4">
            <span className="font-semibold">{t('e_mail') || 'Email'}:</span> {user.email_address || user.email || ''}
          </p>
          <p className="text-sm text-gray-500 mb-4">
            {t('profile.settingsManagedHere') || 'Language and other settings can be changed from the header menu.'}
          </p>
          <Link className="button button-primary" to={ROUTES.HOME}>
            {t('back') || 'Back'}
          </Link>
        </div>
      </div>
    </section>
  )
}

export default ProfilePage
